import { PlusOutlined } from '@ant-design/icons';
import TaggedTooltipButton, { TaggedTooltipButtonOwnProps } from '../TaggedTooltipButton';
import styles from './styles.module.less';

const TaggedAddButton = (props:TaggedTooltipButtonOwnProps) => {
  return (
    <TaggedTooltipButton {...props} icon={<PlusOutlined />} className={styles['green-btn']} />
  );
};

export default TaggedAddButton;
